import { identity } from "lodash";
import { validSumPercentage } from "utils";

export const formFieldsTourist = [
  {
    label: 'Μήνες Λειτουργίας ανά Έτος',
    type: 'select',
    name: 'operatingMonths',
    id: 'operatingMonths',
    placeholder: 'Επιλέξτε Μήνες',
    span: 5,
    asterisk: true,
    className: 'like-text',
    size: 'medium',
    options: Array.from({ length: 12 }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1,
    })),
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Αριθμός Δωματίων',
    type: 'number',
    name: 'roomsNum',
    id: 'roomsNum',
    size: 'large',
    simple: true,
    placeholder: 'Εισάγετε Αριθμό',
    span: 4,
    precision: 0,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: '% Ποσοστό Πληρότητας',
    type: 'numberWithDecimals',
    name: 'occupancyRate',
    id: 'occupancyRate',
    size: 'large',
    span: 5,
    placeholder: 'Εισάγετε %',
    suffix: '%',
    decimalsLimit: 15,
    maxLength: 12,
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return validSumPercentage(parseFloat(value.replaceAll(',', '.')));
        },
      }),
    ],
  },
  {
    label: 'Μέση Ημερήσια Τιμή Δωματίου 1ου Έτους Λειτουργίας (σε €)',
    type: 'formattedNumber',
    name: 'avgRoomDailyRate',
    id: 'avgRoomDailyRate',
    size: 'large',
    className: 'formattedNumberField custom-price-width', //this overrides the span 
    // simple:true,
    // currency:true,
    placeholder: 'Εισάγετε Τιμή',
    span: 10,
    right: true,
    // className: 'formattedNumberField',
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
];
  
  export const formFieldsOther = [
    {
      label: 'Εκτιμώμενη Ποσότητα Προϊόντος ή Υπηρεσίας προς Πώληση',
      type: 'number',
      name: 'estimatedQuantity',
      id: 'estimatedQuantity',
      size: 'large',
      simple: true,
      placeholder: 'Εισάγετε Ποσότητα',
      span: 10,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    {
      label: 'Μέση Τιμή Πώλησης ανά Προϊόν ή Υπηρεσία',
      type: 'formattedNumber',
      name: 'avgSellingPrice',
      id: 'avgSellingPrice',
      size: 'large',
      placeholder: 'Εισάγετε Τιμή',
      span: 10,
      asterisk:true,
      right: true,
      className: 'formattedNumberField',
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      ],
    },
  ]